import { useState, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import useMediaQuery from '@mui/material/useMediaQuery'

import { withRouterProps } from '../../utils'
import { PageLoading, ErrorPage } from '../../components'
import useHomeLifecycle from './useHomeLifecycle'
import { PageContainer, TopRow, MainRow, PlanColumn, SideColumn } from './sections/styles'
import { Greeting, YourPlan, SavingRetiredToggle, HomeAlerts, QuickActions } from './sections'
import { HOME_CHAT_VIEWPORT } from './heyNic'

function AccumulationHome(props) {
  const {
    navigate,
    main: { sidebarActive, toggleSidebar, expandSidebar },
    store: {
      getBaseCase,
      aiStatus,
      config: { onBoarded, spendDownModeling, disableSpendDownModeling },
      features: { enableSpendDown, enableHeyNic },
      auth: { hasStripeSessionId, retailLinkAccount, deleteStripeSessionId },
    },
  } = props
  const [status, setStatus] = useState('loading')
  const wideEnoughForChat = useMediaQuery(HOME_CHAT_VIEWPORT)
  // Whether the side column holds the chat panel rather than the alerts box.
  // HomeAlerts makes the same call for what to render; this side of it only
  // needs to know because the panel drops the column's donut-arc alignment.
  const showChatPanel = !!(enableHeyNic && aiStatus?.available) && wideEnoughForChat

  useHomeLifecycle({
    navigate,
    onBoarded,
    spendDownModeling,
    disableSpendDownModeling,
    hasStripeSessionId,
    retailLinkAccount,
    deleteStripeSessionId,
    sidebarActive,
    toggleSidebar,
    expandSidebar,
  })

  useEffect(() => {
    getBaseCase()
      .then(() => setStatus('success'))
      .catch(err => {
        console.error(err)
        setStatus('error')
      })
  }, [getBaseCase])

  if (status === 'error') {
    return <ErrorPage />
  }

  if (status !== 'success') {
    return <PageLoading />
  }

  const mode = enableSpendDown ? 'retWithinThreeYears' : 'retMoreThanThreeYearsAway'
  const withinThreeYears = mode === 'retWithinThreeYears'

  return (
    <PageContainer>
      <TopRow>
        <Greeting />
        {withinThreeYears && <SavingRetiredToggle />}
      </TopRow>
      <MainRow>
        <PlanColumn>
          <YourPlan mode={mode} />
        </PlanColumn>
        <SideColumn $flush={showChatPanel}>
          <HomeAlerts mode={mode} />
        </SideColumn>
      </MainRow>
      <QuickActions />
    </PageContainer>
  )
}

export default withRouterProps(inject('store', 'main')(observer(AccumulationHome)))
